/**
 * Styled Components - Created by cazarez on 14/05/18.
 */
import styled, { keyframes } from 'styled-components'
import Button from 'antd/lib/button'
import { BLUE, WHITE } from '../../theme/colors'
import Icon from 'antd/lib/icon'
import Popover from 'antd/lib/popover'

interface DivProps {
  secondary?: boolean
}

export const fadeIn = keyframes`
  to {
    opacity: 1;
  }
`

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
`

export const ContainerSelection = styled.div`
  opacity: 0;
  animation: ${fadeIn} 0.6s cubic-bezier(0.67, 0.35, 0.565, 1) both;
`

export const Text = styled.div`
  color: #fff;
`

export const Title = styled.div`
  color: #ededed;
  font-size: 24px;
  fony-family: Avenir;
  font-weight: bold;
  letter-spacing: 0.3px;
  line-height: 33px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 30px;
  position: absolute;
  top: -34px;
  left: calc(50% - 120px);
  background: #272727;
  width: auto;
  margin: 0 auto;
  padding: 1px 32px;
  font-size: 15px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  box-shadow: 0px -1px 4px -1px #828282;
  display: flex;
  align-items: center;
  padding-right: 18px;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  @media (max-width: 698px) {
    box-shadow: 0px -1px 4px -1px #646464;
  }
  &.trigger {
    left: unset;
    top: unset;
    bottom: unset;
    position: unset;
    margin: unset;
  }
`

export const Trigger = styled.div`
  position: sticky;
  bottom: 0px;
  padding-left: 20vw;
  display: inline-flex;
  flex: 1;
  align-items: flex-end;
  @media (max-width: 768px) {
    margin-bottom: -32px;
    flex: unset;
    padding-left: calc(50% - 120px);
  }
`

export const ResellerIcon = styled.img`
  max-width: 344px;
  object-fit: contain;
  display: block;
  @media (max-width: 767px) {
    max-width: 264px;
  }
`

export const AddTeamStoreButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  padding: 10px 30px;
  max-width: 226px;
  border-radius: 22px;
  background-color: #302628;
  color: ${WHITE};
  font-size: 14px;
  letter-spacing: 0.11px;
  line-height: 22px;
  text-align: center;
  @media (max-width: 768px) {
    max-width: 100%;
    margin-top: ${({ secondary }: DivProps) => secondary ? '22px' : '0px'};
  }
  &:hover {
    background-color: white;
    color: #302628;
    border-color: #302628;
  }
`

export const PaginationRow = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 18px;
`

export const FAQSection = styled.div`
  text-align: center;
`

export const FAQBody = styled.div`
  padding: 30px;
  padding-bottom: 10px;
  max-width: 1148px;
  margin: 0 auto;
  text-align: left;
  max-height: 90vh;
  display: block;
  @media (max-width: 698px) {
    padding-bottom: 110px;
  }
  b {
    display: block;
  }
`

export const CreateTeamStoreLegend = styled.div`
  color: #5f6062;
  font-size: 14px;
  font-family: Avenir;
  max-width: 674px;
  max-width: ${({ secondary }: DivProps) => secondary ? '1024px' : '674px'};
  letter-spacing: 0.11px;
  line-height: 23px;
  margin: 12px 0;
  margin-bottom: 20px;
  margin-right: ${({ secondary }: DivProps) => secondary ? '30px' : '12px'};
  span {
    color: #86c800;
  }
  @media (max-width: 480px) {
    width: auto;
    height: auto;
  }
  @media (max-width: 698px) {
    display: none;
  }
`

export const CreateTeamStoreLegendMobile = styled.div`
  max-width: 658px;
  color: #5f6062;
  font-size: 15px;
  letter-spacing: 0.11px;
  line-height: 23px;
  margin-top: -20px;
  display: none;
  @media (max-width: 480px) {
    width: auto;
    height: auto;
  }
  @media (max-width: 698px) {
    display: block;
  }
`

export const DeleteConfirmMessage = styled.div`
  color: #5f6062;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
`

export const TeamsList = styled.div`
  opacity: 0;
  animation: ${fadeIn} 0.6s cubic-bezier(0.67, 0.35, 0.565, 1) both;
  position: relative;
  margin-right: 32px;
  margin-top: 12px;
  @media (max-width: 767px) {
    margin-right: 0px;
  }
`

export const TeamListTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-top: 12px;
  display: inline-block;
  margin-bottom: 12px;
`

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 24px;
  color: #302628;
  @media (max-width: 767px) {
    display: none;
  }
`

export const Row = styled.tr``

export const ListMobile = styled.div`
  display: none;
  flex-flow: column;
  @media (max-width: 768px) {
    display: flex;
  }
`

export const ResellerAbout = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  max-width: 1024px;
  @media (max-width: 698px) {
    margin-block: -24px 24px;
  }
`

export const ResellerFlow = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`

export const ResellerFlowTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 6px;
`

export const ResellerFlowImage = styled.img`
  max-width: 258px;
`

export const MyTeamStoresTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 12px;
  @media (max-width: 768px) {
    display: none;
  }
`

export const StickyArrow = styled(Icon)`
  margin-left: 12px;
  font-size: 16px;
  border-radius: 25px;
  background: #ededed;
  color: #272727;
  padding: 2px;
  padding-top: 1px;
`

export const HeaderWithTooltip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const InfoIcon = styled(Icon)`
  margin-left: 10px;
  font-size: 12px;
  color: ${BLUE};
`

export const PopoverStyled = styled(Popover)`
  cursor: pointer;
`

export const PopoverText = styled.div`
  max-width: 362px;
  width: 100%;
  text-align: center;
  span {
    display: block;
    text-align: center;
    margin-bottom: 10px;
    text-transform: uppercase;
  }
`

export const LoadingContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff6e;
  z-index: 2;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MyTeamStores/styledComponents.tsx